import React from 'react';
import PropTypes from 'prop-types';

const SvgDashboardIcon = ({ color, ...props }) => {
  return (
    <svg
      width={25}
      height={25}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.626 5.5v2h-4v-2h4Zm-10 0v6h-4v-6h4Zm10 8v6h-4v-6h4Zm-10 4v2h-4v-2h4Zm12-14h-8v6h8v-6Zm-10 0h-8v10h8v-10Zm10 8h-8v10h8v-10Zm-10 4h-8v6h8v-6Z"
        fill={color || '#fff'}
      />
    </svg>
  );
};

export default SvgDashboardIcon;

SvgDashboardIcon.propTypes = {
  color: PropTypes.string.isRequired,
};
